const MRow = require('./MRow');

module.exports = class MPadded extends MRow {
  constructor(tag) {
    super(tag);
  }
}